var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"03b899c4634ba4707447270644a6e5b12967bf94"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["resurface-extension@code-cabana"]={id:"03b899c4634ba4707447270644a6e5b12967bf94"};
      